export default __webpack_public_path__ + "static/media/myrecordings.4f1fe931.svg";